export enum ProductType {
  GAS = "gas",
  ELECTRICITY = "electricity",
  HEATING = "heating",
  GLASS_FIBER = "glass_fiber",
}

export const ProductTypeLabel = {
  [ProductType.GAS]: "Gas",
  [ProductType.ELECTRICITY]: "Strom",
  [ProductType.HEATING]: "Fernwärme",
  [ProductType.GLASS_FIBER]: "Glasfaser",
};



// WEBPACK FOOTER //
// ./src/types/ProductType.tsx